import React from 'react'
import { Link } from 'react-router-dom';
import BreadCrumb from '../../../components/BreadCrumb';

export default function HealthcareBanner({ data, breadcrumb, extraClass = ""  }) {
    if (!data) return null;
    return (
        <>
            <section className={`industries-banner ${extraClass}`}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5 col-md-6">
                            <div className="about-bio-box">
                                <div >
                                {/* {data?.buttonText && ( <div className="industries-btn">    <Link  className="default-btn white-btn"> <span>{data?.buttonText}</span> </Link>   </div>     )} */}
                                {breadcrumb && <BreadCrumb data={breadcrumb} />}
                                {data?.title && (<h1 className="heading">{data?.title}</h1>)}
                                {data?.description && (<p> {data?.description}  </p>)}
                                {data?.description2 && (<p> {data?.description2}  </p>)}
                                </div>
                              </div>
                        </div>
                        <div className="col-lg-7 col-md-6"></div>
                    </div>
                </div>
                {data?.image && (<img src={data?.image} className="banner-right-img" alt="Industries" fetchPriority="high" decoding="async" /> )}
            </section>
        </>
    )
}

